import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Pagination, PAGINATION_PAGE_SIZE } from '@/components/Pagination';
import {
  ReportsListHeader,
  ReportsListFilters,
  ReportsTable,
  DuplicateReportModal,
  DeleteReportModal,
} from './components';
import { useReportsList } from './hooks/useReportsList';

export const ReportsListPage: React.FC = () => {
  const navigate = useNavigate();
  const {
    reports,
    loading,
    error,
    total,
    currentPage,
    setCurrentPage,
    search,
    setSearch,
    handleApplySearch,
    handleClearSearch,
    dateRange,
    setDateRange,
    partnerFilter,
    partnerOptions,
    handlePartnerFilterChange,
    copyingReportId,
    handleCopyReport,
    loadReports,
    duplicateModal,
    closeDuplicateModal,
    handleConfirmDuplicate,
    deleteModal,
    closeDeleteModal,
    handleConfirmDelete,
    deletingReportId,
    handleDeleteReport,
    handleStartSend,
    sort,
    toggleSort,
  } = useReportsList();

  return (
    <div className="w-full">
      <ReportsListHeader
        onNewReport={() => navigate('/app/reports/new')}
        partnerFilter={partnerFilter}
        partnerOptions={partnerOptions}
      />

      <hr className="border-gray-200 mt-6 mb-6" />

      <ReportsListFilters
        search={search}
        onSearchChange={setSearch}
        onApplySearch={handleApplySearch}
        onClearSearch={handleClearSearch}
        dateRange={dateRange}
        onDateRangeChange={setDateRange}
        partnerFilter={partnerFilter}
        partnerOptions={partnerOptions}
        onPartnerFilterChange={handlePartnerFilterChange}
      />

      <hr className="border-gray-200 mt-6 mb-6" />

      <ReportsTable
        reports={reports}
        loading={loading}
        error={error}
        itemsPerPage={PAGINATION_PAGE_SIZE}
        copyingReportId={copyingReportId}
        onView={(id) => navigate(`/app/reports/${id}/view`)}
        onEdit={(id) => navigate(`/app/reports/${id}/edit`)}
        onOpenPreview={(id) => window.open(`/app/reports/${id}`, '_blank', 'noopener,noreferrer')}
        onCopy={handleCopyReport}
        onDelete={handleDeleteReport}
        onStartSend={handleStartSend}
        onRetry={loadReports}
        sort={sort}
        onSort={toggleSort}
      />

      <DeleteReportModal
        open={deleteModal !== null}
        reportTitle={deleteModal?.reportTitle ?? ''}
        onConfirm={handleConfirmDelete}
        onCancel={closeDeleteModal}
        isSubmitting={deletingReportId !== null}
      />

      <DuplicateReportModal
        open={duplicateModal !== null}
        defaultTitle={duplicateModal ? `${duplicateModal.reportTitle} (Cópia)` : ''}
        onConfirm={handleConfirmDuplicate}
        onCancel={closeDuplicateModal}
        isSubmitting={copyingReportId !== null}
      />

      {!loading && !error && (
        <Pagination
          currentPage={currentPage}
          totalItems={total}
          onPageChange={setCurrentPage}
        />
      )}
    </div>
  );
};
